import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { reenrichDispatch } from '../api-client';
import { settleWrite } from './unconfirmed-write';

interface ReenrichPayload {
  campaignId: string;
  memberIds: string[];
}

/** Resolves to `{ unconfirmed: true }` when the re-enrich may have gone out but the response was unreadable or cut off. */
export function useReenrichDispatch() {
  const { apiFetch } = useApi();
  return useMutation({
    mutationFn: ({ campaignId, memberIds }: ReenrichPayload) =>
      settleWrite(() => reenrichDispatch(apiFetch, campaignId, memberIds), () => undefined),
  });
}
